import { apiDealFetch } from '..';
import type { CompanyDemandEntryPayload, DemandEntryPayload } from './types';

export const _createDemandEntry = (body: DemandEntryPayload) =>
  apiDealFetch<{ id: string }>('/demand', { method: 'POST', body });

export const _createCompanyDemandEntry = ({
  companyId,
  body,
}: {
  companyId: string;
  body: CompanyDemandEntryPayload;
}) => apiDealFetch<{ id: string }>(`/companies/${companyId}/demand`, { method: 'POST', body });

export const _updateDemandEntry = ({ id, body }: { id: string; body: DemandEntryPayload }) =>
  apiDealFetch<{ success: boolean }>(`/demand/${id}`, { method: 'PUT', body });

export const _removeDemandEntry = (id: string) =>
  apiDealFetch<{ success: boolean }>(`/demand/${id}`, { method: 'DELETE' });
